export function campaignHeaderSubtitle(
  description: string | undefined | null,
  title: string | undefined | null,
  fallback: string,
): string {
  const desc = description?.trim() ?? '';
  const name = title?.trim() ?? '';
  if (desc && desc.localeCompare(name, undefined, { sensitivity: 'accent' }) !== 0) {
    return desc;
  }
  return fallback;
}
